import { ApiProperty } from '@nestjs/swagger'
import { IsNotEmpty, IsPositive } from 'class-validator'

export class CreatePaymentIntentRequest {
	@ApiProperty({ type: Number })
	@IsNotEmpty()
	@IsPositive()
	amount: number
}

export class CreatePaymentIntentResponse {
	@ApiProperty({ type: String })
	id: string

	@ApiProperty({ type: String })
	clientSecret: string
}
